import React, { CSSProperties, FC, useMemo } from 'react';

import { RibbonType } from 'common/contracts';

import { resolveColorDtoToCss } from './BadgeOverlay.utils';

interface IRibbonTextChipProps {
  ribbon: RibbonType;
}

const FALLBACK_TEXT_COLOR = '#ffffff';

export const RibbonTextChip: FC<IRibbonTextChipProps> = ({
  ribbon
}): React.ReactElement => {
  const dynamicStyle = useMemo<CSSProperties>(
    () => ({
      background: resolveColorDtoToCss(
        ribbon.backgroundColor?.colorOne,
        ribbon.backgroundColor?.colorTwo,
        ribbon.backgroundColor?.gradientDirection
      ),
      color: ribbon.textColor?.colorOne || FALLBACK_TEXT_COLOR
    }),
    [ribbon]
  );

  return (
    <span
      className="inline-block whitespace-nowrap rounded-md px-2.5 py-1 text-xs font-semibold shadow-[0_1px_3px_rgba(0,0,0,0.2)]"
      style={dynamicStyle}
    >
      {ribbon.text}
    </span>
  );
};
